<div id="wrapper" [style.height]="(isLoading || filteredContractOffers.length === 0) ? 'calc(100% - 98px)' : 'auto'">
  <div class="container">
    <mat-form-field class="connector-selector" color="accent">
      <mat-label>Select Connector</mat-label>
      <mat-icon matPrefix>menu_book</mat-icon>
      <mat-select [(ngModel)]="selectedConnector" (selectionChange)="onConnectorChange()">
        <mat-option *ngFor="let connector of availableConnectors" [value]="connector.key">
          {{ connector.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-form-field" color="accent">
      <mat-label>Search by name or Id</mat-label>
      <input (input)="onSearch()" [(ngModel)]="searchText" matInput>
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <!-- <button mat-button (click)="onSearch()">Search</button> -->
  </div>

  <div *ngIf="isLoading" class="empty-wrapper">
    <div class="loading-message">
      <mat-spinner style="margin: 0 auto;" color="accent"></mat-spinner>
      <h2>Loading catalog...</h2>
      <p>Fetching assets from connector...</p>
    </div>

    <div *ngIf="!isLoading && filteredContractOffers.length === 0" class="no-assets-message">
      <mat-icon style="font-size: 64px; width: 64px; height: 64px;">menu_book</mat-icon>
      <h2>No data offers available</h2>
      <p>The selected connector doesn't have any data offers in its catalog.</p>
      <p>Make sure other connectors are running or try selecting a different one.</p>
    </div>
  </div>


  <div *ngIf="!isLoading && filteredContractOffers.length > 0" class="cards-grid">

    <mat-card *ngFor="let contractOffer of filteredContractOffers" class="asset-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>menu_book</mat-icon>
        <mat-card-title>{{contractOffer.properties.name}}</mat-card-title>
      </mat-card-header>
      <mat-divider class="asset-header-divider"></mat-divider>
      <mat-card-content>
        <div class="asset-properties">
          <div class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>category</mat-icon>
              <div class="asset-property-header">Type</div>
            </div>
            <div class="asset-property-value">
              {{ getDcatType(contractOffer) || contractOffer.properties.type }}
            </div>
          </div>

          <div class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>key</mat-icon>
              <div class="asset-property-header">Id</div>
            </div>
            <div class="asset-property-value">{{contractOffer.assetId}}</div>
          </div>

          <div *ngIf="contractOffer.originator" class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>link</mat-icon>
              <div class="asset-property-header">Originator</div>
            </div>
            <div class="asset-copy-field">
              <input class="asset-readonly-field" type="text" [value]="contractOffer.originator" readonly
                (focus)="selectReadonlyField($event)">
              <button type="button" aria-label="Copy originator"
                (click)="copyToClipboard(contractOffer.originator || '')">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
        </div>


        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Additional properties
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="asset-properties">
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">numbers</mat-icon>
                <div class="asset-property-header">Version</div>
              </div>
              <div class="asset-property-value">{{contractOffer.properties.version}}</div>
            </div>
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">content_paste</mat-icon>
                <div class="asset-property-header">Content-Type</div>
              </div>
              <div class="asset-property-value">{{contractOffer.properties.contentType}}</div>
            </div>
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">fingerprint</mat-icon>
                <div class="asset-property-header">Contract Id</div>
              </div>
              <div class="asset-property-value">{{contractOffer.id}}</div>
            </div>
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">person</mat-icon>
                <div class="asset-property-header">Assigner</div>
              </div>
              <div class="asset-property-value">{{contractOffer.assigner}}</div>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="getDisplayedPolicy(contractOffer) as policy">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Policy
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="asset-properties">
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">gavel</mat-icon>
                <div class="asset-property-header">Policy Type</div>
              </div>
              <div class="asset-property-value">{{policy['@type']}}</div>
            </div>
            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">fingerprint</mat-icon>
                <div class="asset-property-header">Policy ID</div>
              </div>
              <div class="asset-property-value">{{getPolicyId(policy) || '-'}}</div>
            </div>

            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">rule</mat-icon>
                <div class="asset-property-header">Permissions</div>
              </div>
            </div>

            <ng-container *ngIf="getPolicyPermissions(policy).length; else noPermissions">
              <mat-expansion-panel *ngFor="let permission of getPolicyPermissions(policy); let permissionIndex = index">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Permission {{permissionIndex + 1}}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="asset-properties">
                  <div class="asset-property-row">
                    <div class="asset-property-top">
                      <mat-icon class="expansion-icon-white">rule</mat-icon>
                      <div class="asset-property-header">Action</div>
                    </div>
                    <div class="asset-property-value">{{getPermissionAction(permission)}}</div>
                  </div>

                  <ng-container *ngFor="let constraint of getPolicyConstraints(permission)">
                    <div class="asset-property-row">
                      <div class="asset-property-top">
                        <mat-icon class="expansion-icon-white">tune</mat-icon>
                        <div class="asset-property-header">Constraint</div>
                      </div>
                      <div class="asset-property-value">
                        <div><b>Left Operand:</b> {{getConstraintValue(constraint, 'odrl:leftOperand')}}</div>
                        <div><b>Operator:</b> {{getConstraintValue(constraint, 'odrl:operator')}}</div>
                        <div><b>Right Operand:</b> {{getFormattedRightOperand(constraint)}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-expansion-panel>
            </ng-container>

            <ng-template #noPermissions>
              <div class="asset-property-row">
                <div class="asset-property-value">No permissions</div>
              </div>
            </ng-template>

            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">block</mat-icon>
                <div class="asset-property-header">Prohibitions</div>
              </div>
            </div>

            <ng-container *ngIf="getPolicyProhibitions(policy).length; else noProhibitions">
              <mat-expansion-panel
                *ngFor="let prohibition of getPolicyProhibitions(policy); let prohibitionIndex = index">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Prohibition {{prohibitionIndex + 1}}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="asset-properties">
                  <div class="asset-property-row">
                    <div class="asset-property-top">
                      <mat-icon class="expansion-icon-white">rule</mat-icon>
                      <div class="asset-property-header">Action</div>
                    </div>
                    <div class="asset-property-value">{{getPermissionAction(prohibition)}}</div>
                  </div>

                  <ng-container *ngFor="let constraint of getPolicyConstraints(prohibition)">
                    <div class="asset-property-row">
                      <div class="asset-property-top">
                        <mat-icon class="expansion-icon-white">tune</mat-icon>
                        <div class="asset-property-header">Constraint</div>
                      </div>
                      <div class="asset-property-value">
                        <div><b>Left Operand:</b> {{getConstraintValue(constraint, 'odrl:leftOperand')}}</div>
                        <div><b>Operator:</b> {{getConstraintValue(constraint, 'odrl:operator')}}</div>
                        <div><b>Right Operand:</b> {{getFormattedRightOperand(constraint)}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-expansion-panel>
            </ng-container>

            <ng-template #noProhibitions>
              <div class="asset-property-row">
                <div class="asset-property-value">No prohibitions</div>
              </div>
            </ng-template>

            <div class="asset-property-row">
              <div class="asset-property-top">
                <mat-icon class="expansion-icon-white">task_alt</mat-icon>
                <div class="asset-property-header">Obligations</div>
              </div>
            </div>

            <ng-container *ngIf="getPolicyObligations(policy).length; else noObligations">
              <mat-expansion-panel *ngFor="let obligation of getPolicyObligations(policy); let obligationIndex = index">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Obligation {{obligationIndex + 1}}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="asset-properties">
                  <div class="asset-property-row">
                    <div class="asset-property-top">
                      <mat-icon class="expansion-icon-white">rule</mat-icon>
                      <div class="asset-property-header">Action</div>
                    </div>
                    <div class="asset-property-value">{{getPermissionAction(obligation)}}</div>
                  </div>

                  <ng-container *ngFor="let constraint of getPolicyConstraints(obligation)">
                    <div class="asset-property-row">
                      <div class="asset-property-top">
                        <mat-icon class="expansion-icon-white">tune</mat-icon>
                        <div class="asset-property-header">Constraint</div>
                      </div>
                      <div class="asset-property-value">
                        <div><b>Left Operand:</b> {{getConstraintValue(constraint, 'odrl:leftOperand')}}</div>
                        <div><b>Operator:</b> {{getConstraintValue(constraint, 'odrl:operator')}}</div>
                        <div><b>Right Operand:</b> {{getFormattedRightOperand(constraint)}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-expansion-panel>
            </ng-container>

            <ng-template #noObligations>
              <div class="asset-property-row">
                <div class="asset-property-value">No obligations</div>
              </div>
            </ng-template>


          </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="contractOffer['dcat:dataset']">
          <mat-expansion-panel-header>
            <mat-panel-title>
              DCAT Dataset
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="asset-properties">
            <ng-container *ngFor="let dataset of contractOffer['dcat:dataset']">
              <ng-container *ngIf="dataset['@id'] === contractOffer.assetId">

                <div class="asset-property-row">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">fingerprint</mat-icon>
                    <div class="asset-property-header">ID</div>
                  </div>
                  <div class="asset-property-value">{{dataset['@id']}}</div>
                </div>
                <div class="asset-property-row">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">category</mat-icon>
                    <div class="asset-property-header">Type</div>
                  </div>
                  <div class="asset-property-value">{{dataset['@type']}}</div>
                </div>
                <div class="asset-property-row">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">label</mat-icon>
                    <div class="asset-property-header">Name</div>
                  </div>
                  <div class="asset-property-value">{{dataset.name}}</div>
                </div>
                <div class="asset-property-row">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">numbers</mat-icon>
                    <div class="asset-property-header">Version</div>
                  </div>
                  <div class="asset-property-value">{{dataset.version}}</div>
                </div>
                <div class="asset-property-row">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">content_paste</mat-icon>
                    <div class="asset-property-header">Content Type</div>
                  </div>
                  <div class="asset-property-value">{{dataset.contenttype}}</div>
                </div>
                <div class="asset-property-row" *ngIf="dataset['dcat:distribution']">
                  <div class="asset-property-top">
                    <mat-icon class="expansion-icon-white">cloud_download</mat-icon>
                    <div class="asset-property-header">Distributions</div>
                  </div>
                  <div class="asset-property-value">
                    <ul style="margin: 0;">
                      <li *ngFor="let dist of dataset['dcat:distribution']">
                        <span><b>Format:</b> {{dist['dct:format']['@id']}}</span>
                        <span *ngIf="dist['dcat:accessService']"> | <b>Endpoint:</b>
                          {{dist['dcat:accessService']['dcat:endpointUrl']}}</span>
                      </li>
                    </ul>
                  </div>
                </div>

              </ng-container>
            </ng-container>
          </div>
        </mat-expansion-panel>

      </mat-card-content>

      <mat-card-footer class="asset-card-footer">
        <button (click)="onNegotiateClicked(contractOffer)"
          [disabled]="isBusy(contractOffer) || isNegotiated(contractOffer)" color="accent" class="card-footer-button"
          mat-flat-button>
          <mat-icon>drive_file_rename_outline</mat-icon>
          Negotiate
        </button>
        <mat-progress-bar *ngIf="isBusy(contractOffer)" color="accent" mode="indeterminate"></mat-progress-bar>
      </mat-card-footer>
    </mat-card>
  </div>

  <mat-paginator *ngIf="filteredContractOffers.length" [length]="filteredContractOffers.length" hidePageSize="true"
    [pageSize]="filteredContractOffers.length">
  </mat-paginator>
</div>